export default __webpack_public_path__ + "static/media/bee.939085ed.png";